<template>
<!-- 创建/编辑 单选题/多选题/不定项/判断题/填空题/主观题 -->
    <div class="board">
        <div v-hasPermi="[$route.query.editId?'questionBank:question:update':'questionBank:question:add']">
            <div class="title">
                <span>
                    <el-button
                            type="text"
                            icon="el-icon-arrow-left"
                            @click="$router.push({path:'/question',query:{id:$route.query.parentId}})">
                        {{ questionEditTextConfig.back }}
                    </el-button>
                    <el-divider direction="vertical"></el-divider>
                    <span class="name">{{($route.query.editId?questionEditTextConfig.edit:questionEditTextConfig.add)+type}}</span>
                </span>
            </div>
            <div style="height:calc(100% - 83px);overflow:auto">
                <el-form id="formEditQuestion" class="left" label-position="right" style="max-width:1000px;margin:auto">
                    <p v-for="(err,n) in error" :key="n" style="color:rgb(245, 108, 108);margin:0 30px 5px;font-weight:600;font-size:15px">{{err}}</p>
                    <br />

                    <!-- 评阅方式 -->
                    <el-form-item :label="formTextConfig.reviewMethod" label-width="70px" v-if="form.type == 'subjectivity'">
                        <el-radio v-model="form.review_mode" v-for="item in reviewModeOptions" :key="item.id" :label="item.dict_value" @change="reviewModeChange"  style="display:block;padding-top:15px">
                            {{ item.dict_label }}
                        </el-radio>
                    </el-form-item>

                    <el-form-item :label="formTextConfig.stem" label-width="70px">
                        <quill-editor
                                :value.sync="form.stem"
                                :fill="form.type == 'fill'"
                                :placeholder="formTextConfig.stemTip">
                        </quill-editor>
                        <p class="info" v-if="form.type == 'fill'">{{ formTextConfig.fillTip }}</p>
                    </el-form-item>
                    <el-form-item label-width="70px" :label="formTextConfig.attachment">
                        <el-tag
                                v-if="form.attachment.stem"
                                :key="key"
                                :closable="true"
                                :disable-transitions="true"
                                @close="form.attachment.stem=undefined,key+=1"
                                size="medium">
                            <a :href="config_env.BASE_URL+getDownloadAddress(form.attachment.stem.file_path,form.attachment.stem.file_name)"
                               target="_blank">
                                <i class="el-icon-download"></i>
                                {{form.attachment.stem.file_name}}
                            </a>
                        </el-tag>
                        <el-button
                                v-else
                                @click="enclosure=0,importDialogVisible=true"
                                type="primary"
                                plain>
                            {{ formTextConfig.attachmentUpload }}
                        </el-button>
                    </el-form-item>
                    <el-form-item :label="form.crosshead&&form.crosshead.length?formTextConfig.totalScore:formTextConfig.score" label-width="70px">
                        <el-input-number v-if="form.crosshead && !form.crosshead.length" v-model="form.score" :min="0" :step="0.1" step-strictly></el-input-number>
                        <el-input v-else v-model="form.score" disabled></el-input>
                        <p class="info" v-if="form.crosshead&&form.crosshead.length">{{ formTextConfig.scoreTip }}</p>
                    </el-form-item>
                    <div v-if="form.type == 'subjectivity'">
                        <el-form-item label-width="70px" :label="formTextConfig.crosshead" v-if="form.crosshead.length>0">
                            <div v-for="(q,i) in form.crosshead" >
                                <el-form-item label-width="60px" :label="'（'+(i+1)+'）'">
                                    <el-row style="display:flex;">
                                        <quill-editor
                                                class="editor"
                                                :value.sync="q.stem"
                                                :placeholder="formTextConfig.crossheadTip.signMix(i + 1)">
                                        </quill-editor>
                                        <el-button
                                                type="danger"
                                                plain
                                                size="mini"
                                                icon="el-icon-delete"
                                                @click="form.crosshead.splice(i,1),num+=1">
                                        </el-button>
                                    </el-row>
                                </el-form-item>
                                <el-form-item :label="formTextConfig.score" label-width="60px">
                                    <el-input-number  @blur="changeScore(),num+=1" @change="changeScore()" v-model="q.score" :min="0" :step="0.1" step-strictly></el-input-number>
                                </el-form-item>
                            </div>
                        </el-form-item>

                        <!-- 脚本 -->
                        <el-form-item :label="formTextConfig.script" label-width="70px" v-if="form.type == 'subjectivity' && form.review_mode === 'script'">
                            <el-input
                                type="textarea"
                                :placeholder="formTextConfig.scriptTip"
                                v-model="form.review_script"
                                show-word-limit
                            ></el-input>
                        </el-form-item>

                        <el-form-item label-width="70px">
                            <el-button
                                    type="primary"
                                    plain
                                    @click="form.crosshead.push({stem:'',score:2}),changeScore()"
                                    style="width:100%">
                                {{ formTextConfig.addCrosshead }}
                            </el-button>
                        </el-form-item>
                    </div>

                    <el-form-item label-width="70px" :label="answerTextConfig.name" v-if="form.type != 'fill'">
                        <el-radio-group v-model="form.answer[0]" v-if="form.type == 'single_choice'">
                            <el-form-item v-for="(f,j) in form.choices" :key="j+num" label-width="70px">
                                <template slot="label">
                                    <el-radio :label="j"><i>{{letter[j]}}.</i></el-radio>
                                </template>
                                <el-row style="display:flex;">
                                    <quill-editor
                                            class="editor"
                                            :value.sync="form.choices[j]"
                                            :key="j"
                                            :placeholder="answerTextConfig.formatter.signMix(letter[j])">
                                    </quill-editor>
                                    <el-button
                                            type="danger"
                                            plain
                                            size="mini"
                                            icon="el-icon-delete"
                                            @click="form.choices.splice(j,1),num+=1"
                                            v-if="form.choices.length>3&&form.type == 'single_choice'">
                                    </el-button>
                                </el-row>
                            </el-form-item>
                        </el-radio-group>
                        <el-radio-group v-model="form.answer[0]" v-if="form.type == 'determine'" style="line-height:52px">
                            <el-radio :label="1">{{ answerTextConfig.determine.right }}</el-radio>
                            <el-radio :label="0">{{ answerTextConfig.determine.error }}</el-radio>
                        </el-radio-group>
                        <el-checkbox-group v-model="form.answer" v-if="form.type == 'choice' || form.type == 'uncertain_choice'">
                            <el-form-item v-for="(f,j) in form.choices" :key="j+num" label-width="50px">
                                <template slot="label">
                                    <el-checkbox :label="j"><i>{{letter[j]}}.</i></el-checkbox>
                                </template>
                                <el-row style="display: flex;">
                                    <quill-editor
                                            class="editor"
                                            :value.sync="form.choices[j]"
                                            :key="j"
                                            :placeholder="answerTextConfig.formatter.signMix(letter[j])">
                                    </quill-editor>
                                    <el-button
                                            type="danger"
                                            plain
                                            size="mini"
                                            icon="el-icon-delete"
                                            @click="form.choices.splice(j,1),num+=1"
                                            v-if="form.choices.length>3">
                                    </el-button>
                                </el-row>
                            </el-form-item>
                        </el-checkbox-group>
                        <quill-editor
                                v-if="form.type == 'subjectivity'"
                                :value.sync="form.answer[0]"
                                :placeholder="answerTextConfig.inputTip">
                        </quill-editor>
                    </el-form-item>
                    <el-form-item
                            label-width="70px"
                            v-if="(form.type == 'single_choice' || form.type == 'choice' || form.type == 'uncertain_choice') && (form.choices.length<letter.length)">
                        <el-button type="primary" plain @click="form.choices.push('')" style="width:100%">{{ answerTextConfig.add }}</el-button>
                    </el-form-item>
                    <el-form-item label-width="70px" :label="answerTextConfig.attachment" v-if="form.type == 'subjectivity'">
                        <el-tag
                                v-if="form.attachment.answer"
                                :key="key"
                                :closable="true"
                                :disable-transitions="true"
                                @close="form.attachment.answer=undefined,key+=1"
                                size="medium">
                            <a :href="config_env.BASE_URL+getDownloadAddress(form.attachment.answer.file_path,form.attachment.answer.file_name)" target="_blank">
                                <i class="el-icon-download"></i>
                                {{form.attachment.answer.file_name}}
                            </a>
                        </el-tag>
                        <el-button
                                v-else
                                @click="enclosure=1,importDialogVisible=true"
                                type="primary"
                                plain>
                            {{ answerTextConfig.upload }}
                        </el-button>
                    </el-form-item>
                    <el-form-item :label="formTextConfig.analysis" label-width="70px">
                        <quill-editor :value.sync="form.analysis" :placeholder="formTextConfig.analysisTip"></quill-editor>
                    </el-form-item>
                    <el-form-item label-width="70px" :label="formTextConfig.analysisAttachment">
                        <el-tag
                                v-if="form.attachment.analysis"
                                :key="key"
                                :closable="true"
                                :disable-transitions="true"
                                @close="form.attachment.analysis=undefined,key+=1"
                                size="medium">
                            <a :href="config_env.BASE_URL+getDownloadAddress(form.attachment.analysis.file_path,form.attachment.analysis.file_name)" target="_blank">
                                <i class="el-icon-download"></i>
                                {{form.attachment.analysis.file_name}}
                            </a>
                        </el-tag>
                        <el-button
                                v-else
                                @click="enclosure=2,importDialogVisible=true"
                                type="primary"
                                plain>
                            {{ formTextConfig.analysisAttachmentUpload }}
                        </el-button>
                    </el-form-item>

                    <!-- 实训环境 -->
                    <el-form-item :label="formTextConfig.training" label-width="70px" v-if="form.type == 'subjectivity' && trainingEnable">
                        <el-select v-model="form.training_label" :key="num" @change="num+=1; trainingChange($event)" :placeholder="formTextConfig.trainingTip">
                            <el-option :label="formTextConfig.nullTraining" :value="formTextConfig.nullTraining"></el-option>
                            <el-option v-for="f in trainingOptions" :label="f.label" :value="f.label" :platformMark="f.platform_mark" v-if="form.review_mode=='manual'|| f.platform_mark=='ws_cloud'"></el-option>
                        </el-select>
                    </el-form-item>

                    <div class="specifications-list-container" v-if="show_project_url || has_bill">
                        <el-form-item :label="formTextConfig.projectUrl" label-width="70px" v-if="form.type == 'subjectivity' && trainingEnable && show_project_url">
                            <el-input v-model="project_url" :placeholder="formTextConfig.projectUrlTip"></el-input>
                        </el-form-item>
                        <el-form-item :label="formTextConfig.specification" label-width="70px" v-if="form.type == 'subjectivity' && trainingEnable && has_bill">
                            <ul class="specifications-list">
                                <li :class="item.id == specification_id?'selected':''"  v-for="item in specificationList" @click="changeSpecification(item)">
                                    <h5>{{item.title}}</h5>
                                    <p><span class="label">{{formTextConfig.cpuCores}}</span>{{item.cpuCores}}核</p>
                                    <p><span class="label">{{formTextConfig.memory}}</span>{{item.memory}}MB</p>
                                    <p><span class="label">{{formTextConfig.provider}}</span>{{item.provider}}</p>
                                    <p><span class="label">{{formTextConfig.price}}</span>{{item.currentPrice ?item.currentPrice:item.price}}元 /
                                        {{item.priceUnit=="min"?"分钟":"小时"}}</p>
                                    <i class="selected-icon es-icon es-icon-done"></i>
                                </li>
                            </ul>
                        </el-form-item>
                        <el-form-item :label="formTextConfig.giftDuration" label-width="70px" v-if="form.type == 'subjectivity' && trainingEnable && has_bill">
                            <el-row>
                                <el-col :span="6">
                                    <el-input type="number" v-model="gift_duration" :placeholder="formTextConfig.giftDurationTip" @input="changeGiveDuration()"></el-input>
                                </el-col>
                                <el-col :span="18" style="padding-left:10px">
                                    <span>{{priceUnitLabel}}</span>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item label="" label-width="70px" v-if="form.type == 'subjectivity' && trainingEnable && has_bill">
                            <span>将在ModelEasy平台获赠{{tipdm_icon}}泰迪币</span>
                        </el-form-item>
                    </div>

                    <!-- 答题方式 -->
                    <el-form-item label="答题方式" label-width="70px" v-if="form.type == 'subjectivity'">
                        <el-checkbox-group v-model="form.submit_mode" :disabled="form.review_mode === 'script'">
                            <el-checkbox v-for="item in submitModeOptions" :label="item.dict_value" :key="item.id">{{ item.dict_label }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <!-- 难度 -->
                    <el-form-item :label="formTextConfig.difficulty" label-width="70px">
                        <el-radio-group v-model="form.difficulty" style="padding-top:13px;">
                            <el-radio v-for="d in difficultyOptions" :key="d.dict_value" :label="d.dict_value">{{d.dict_label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="formTextConfig.tag" label-width="70px">
                        <el-cascader
                                v-model="tag_ids"
                                class="editor100p"
                                @change="changeTag"
                                :placeholder="formTextConfig.tagTip"
                                :options="tagOptions"
                                :props="tagProps"
                                filterable
                                clearable>
                            <template slot-scope="{ node, data }">
                                <span>{{ data.name }}</span>
                                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                            </template>
                        </el-cascader>
                    </el-form-item>
                    <el-form-item :label="formTextConfig.type" label-width="70px" v-if="form.type === 'single_choice' || form.type === 'choice' || form.type === 'uncertain_choice'">
                        <el-select v-model="form.type" @change="typeChange(form.type)" :placeholder="formTextConfig.typeTip" class="editor">
                            <el-option
                                    v-for="item in typeList"
                                    v-if="item.dict_value === 'single_choice' || item.dict_value === 'choice' || item.dict_value === 'uncertain_choice'"
                                    :key="item.id"
                                    :value="item.dict_value"
                                    :label="item.dict_label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="70px" style="margin:15px 0">
                        <el-button
                                type="primary"
                                @click="fullscreenLoading = true, save(1)"
                                v-if="!$route.query.editId">
                            {{ formTextConfig.saveAndContinue }}
                        </el-button>
                        <el-button
                                type="primary"
                                @click="fullscreenLoading = true, save()"
                                :disabled="fullscreenLoading">
                            {{ formTextConfig.save.name }}
                        </el-button>
                        <el-button
                                @click="$router.push({path:'/question',query:{id:$route.query.parentId}})">
                            {{ formTextConfig.cancel }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <file-upload :show.sync="importDialogVisible" @close="close"></file-upload>
        </div>
    </div>
</template>

<script>
import quillEditor from '@/components/editor/index.vue'
import fileUpload from '@/components/fileUpload/index.vue'
import { getDownloadAddress } from '@/utils/common.js'
import {getDict} from "@/api/dict";
import {getSpecificationList} from "@/api/specification.js";
export default {
    name: 'questionEdit',
    components: {
        quillEditor, fileUpload
    },
    data() {
        return {
            typeList: [],
            type: '',
            letter: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
            form: {
                id: null,
                type: this.$route.query.type,
                attachment: {},
                stem: ' ',
                answer:[' '],
                choices:[],
                crosshead:[],
                analysis:' ',
                difficulty:'normal',
                score: 2,
                tag_ids:null,
                review_mode: 'manual',
                submit_mode: ['text', 'attachment', 'link'],
                review_script: '',
                training_mirror: null,
                training_label: null,
                training_bill: null
            },
            show_project_url: false,
            project_url: '',
            has_bill: null,
            priceUnitLabel: null,
            specification_id: null,
            gift_duration: null,
            difficultyOptions: [],
            tagProps: { multiple: true, expandTrigger: 'hover', emitPath: false, value: 'id', label: 'name' },
            tagOptions: [],
            tag_ids: null,
            row: null,
            num: 0,
            is_valid:true,
            error:[],
            fullscreenLoading: false,
            importDialogVisible: false,
            enclosure: null,
            key: 0,
            reviewModeOptions: [],
            submitModeOptions: [],
            trainingOptions: [],
            specificationList: [],
            tipdm_icon:"",
            price: null

        }
    },
    computed: {
        trainingEnable() {
            return this.$store.state.global.textConfig.training.enable
        },
        questionEditTextConfig() {
            return this.$store.state.global.textConfig.backend.questionEdit
        },
        formTextConfig() {
            return this.questionEditTextConfig.form
        },
        answerTextConfig() {
            return this.formTextConfig.answer
        },
        saveTextConfig() {
            return this.formTextConfig.save
        },
    },
    async created() {
        getDict('review_mode').then(res => {
            this.reviewModeOptions = res.data.filter(item => item.dict_value !== 'objective')
        })
        getDict('submit_mode').then(res => {
            this.submitModeOptions = res.data.filter(item => item.dict_value !== 'objective')
        })

        await getSpecificationList().then(res => {
            this.specificationList = res.data
        })

        if (this.trainingEnable) {
            await this.$store.dispatch("getTrainingMirrorList").then(res => {
                this.trainingOptions = res.data
            })
        }

        this.form.choices = ['', '', '', '']
        this.form.id = this.$route.query.editId
        this.form.type = this.$route.query.type
        if(this.form.type === 'choice') {
            this.form.answer = [0,1]
        }else if(this.form.type === 'uncertain_choice'||this.form.type === 'single_choice') {
            this.form.answer = [0]
        }else if(this.form.type === 'determine') {
            this.form.choices = []
            this.form.answer = [1]
        }else if(this.form.type === 'subjectivity') {
            this.form.choices = ''
            this.form.training_mirror = ''
            this.form.crosshead = []
            this.form.answer = [' ']
        }
        if (this.$route.query.editId) {
            this.$store.dispatch("getQuestionPreview", this.$route.query.editId).then(res => {
                this.form = res.data
                if (!res.data.attachment) {
                    this.form.attachment = {}
                }else {
                    this.form.attachment = res.data.attachment
                }
                if (this.form.type === 'determine') {
                    this.form.answer[0] = Number(this.form.answer[0])
                }
                if (this.form.type === 'choice' || this.form.type === 'uncertain_choice' || this.form.type === 'single_choice') {
                    this.num += 1
                    for (let i = 0; i < this.form.answer.length; i++) {
                        const e = this.form.answer[i];
                        this.form.answer[i] = Number(e)
                    }
                }else if(this.form.type === 'subjectivity') {
                    if (!this.form.submit_mode) {
                        this.$set(this.form, 'submit_mode',  [])
                    }
                    let train = this.trainingOptions.find(x=>x.label == this.form.training_label)
                    if (train) {
                        this.has_bill = train.has_bill
                        if (train.platform_mark == 'external_url' && train.value == '' ) {
                            this.show_project_url = true
                            this.project_url = this.form.training_mirror
                        }
                        if (this.has_bill && this.form.training_bill) {
                            this.gift_duration = this.form.training_bill.gift_duration
                            this.specification_id = this.form.training_bill.specification_id
                            let specification = this.specificationList.find(x=>x.id == this.specification_id)
                            if (specification) {
                                if (specification.priceUnit == 'min') {
                                    this.priceUnitLabel = "分钟"
                                } else {
                                    this.priceUnitLabel = "小时"
                                }
                                this.price = specification.currentPrice ?specification.currentPrice:specification.price
                                this.changeGiveDuration()
                            }
                        }
                    }
                }

                this.tag_ids = []
                if (this.form.tag_ids) {
                    if (this.form.tag_ids.indexOf(',') != -1) {
                        this.tag_ids = this.form.tag_ids.split(',')
                    }else {
                        this.tag_ids = [this.form.tag_ids]
                    }
                }
            })
        }else{
            this.form.id = this.$route.query.id
        }
        this.$store.dispatch("getDict", 'question_type').then(res => {
            this.typeList = res.data
            for (let i = 0; i < this.typeList.length; i++) {
                if (this.typeList[i].dict_value == this.form.type) {
                    this.type = this.typeList[i].dict_label
                    this.form.type = this.typeList[i].dict_value
                }
            }
        });
        this.$store.dispatch("getDict", 'question_difficulty').then(res => {
            this.difficultyOptions = res.data
        });
        this.$store.dispatch("getQuestionTagList").then(res => {
            this.tagOptions = []
            for (let i = 0; i < res.data.length; i++) {
                const e = res.data[i];
                if (i!=(res.data.length-1)) {
                    this.tagOptions.push(e)
                }else {
                    this.tagOptions.push(...e.children)
                }
            }
        })
    },
    methods: {
        reviewModeChange(reviewMode) {
            if (reviewMode === 'script') {
                let selected = this.trainingOptions.find(item => item.label === this.form.training_label)
                if (selected && selected.platform_mark != 'ws_cloud') {
                    this.form.training_mirror = null
                    this.form.training_label = null
                    this.has_bill = false
                    this.project_url = '';
                    this.show_project_url = false
                    this.specification_id = null
                    this.gift_duration = null
                }
                this.form.submit_mode = []
            } else if (reviewMode === 'manual') {
                this.form.submit_mode = ['text', 'attachment', 'link']
            } else if (reviewMode === 'objective') {
                this.form.submit_mode = []
            }
        },
        trainingChange(val) {
            let selected = this.trainingOptions.find(item => item.label === val)
            this.form.platform_mark = selected ? selected.platform_mark : null
            if (selected) {
                this.form.training_mirror = selected.value
                this.has_bill = selected.has_bill
                if (!this.has_bill) {
                    this.specification_id = null
                    this.gift_duration = null
                }
                if (selected.platform_mark == 'external_url' && selected.value == "" ) {
                    this.show_project_url = true
                } else {
                    this.show_project_url = false
                    this.project_url = ''
                }
            } else  {
                this.has_bill = false
                this.show_project_url = false
                this.project_url = ''
                this.specification_id = null
                this.gift_duration = null
                this.form.training_mirror = ''
            }

        },
        getDownloadAddress,
        typeChange(type) {
            document.getElementById('formEditQuestion').scrollIntoView()
            this.type = this.questionTypeFormatter(type)
            if(type == 'single_choice') {
                this.form.answer = [0]
            }else if(type == 'choice') {
                this.form.answer = [0,1]
            }else if(type == 'uncertain_choice') {
                this.form.answer = [0]
            }
            this.$message({
                message: this.formTextConfig.changeMessage.signMix(this.type),
                type: 'warning'
            })
        },
        changeTag() {
            if (this.tag_ids.length>8) {
                this.$message({
                    type: 'error',
                    message: this.formTextConfig.tooMany
                });
                this.tag_ids = this.tag_ids.slice(0,8)
            }
            this.form.tag_ids = this.tag_ids.join(',')
        },
        reset() {
            this.$refs['form'].resetFields();
        },
        changeScore() {
            this.form.score = 0
            this.form.crosshead.map(e=>{
                if (e.score === undefined) {
                    this.form.score += 0
                } else {
                    this.form.score += e.score
                }
            })
            this.form.score = this.form.score.toFixed(1)
        },
        close(data) {
            this.importDialogVisible = false
            if (this.enclosure === 0) {
                this.form.attachment.stem = data
            }else if (this.enclosure === 1) {
                this.form.attachment.answer = data
            }else {
                this.form.attachment.analysis = data
            }
        },
        save(val) {
            this.is_valid = true
            this.error = []
            let form = JSON.parse(JSON.stringify(this.form))
            if (form.stem == " " || form.stem == "") {
                this.error.push(this.saveTextConfig.nullStem)
                this.is_valid = false
            }
            if(form.type == 'single_choice' || form.type == 'choice' || form.type == 'uncertain_choice') {
                let choices = form.choices
                for (let j = 0; j < choices.length; j++) {
                    const e = choices[j];
                    if (e.length>0) {
                    }else{
                        this.error.push(this.saveTextConfig.choice.nullMessage.signMix(this.letter[j]))
                        this.is_valid = false
                    }
                }
                if (choices.length<3) {
                    this.error.push(this.saveTextConfig.choice.tooLittle)
                    this.is_valid = false
                }
                if (form.type == 'choice' && form.answer.length<2) {
                    this.error.push(this.saveTextConfig.choice.answerTooLittle)
                    this.is_valid = false
                }
                if (form.type == 'uncertain_choice' && form.answer.length<1) {
                    this.error.push(this.saveTextConfig.choice.nullUncertain)
                    this.is_valid = false
                }
            }else if (form.type == 'fill') {
                form.answer = []
                let str = form.stem;
                let a = str.match(/(\[\[=?)(.*?)(?=\]\])/g)
                if (!a) {
                    this.error.push(this.saveTextConfig.fill.nullMessage)
                    this.is_valid = false
                }else {
                    let err = false
                    for (let j = 0; j < a.length; j++) {
                        if ((a[j].trim()).length<3) {
                            err = true
                        }
                    }
                    if (err) {
                        this.error.push(this.saveTextConfig.fill.nullMessage2)
                        this.is_valid = false
                    }
                }
            }else if (form.type == 'subjectivity') {
                if (form.crosshead.length) {
                    for (let l = 0; l < form.crosshead.length; l++) {
                        const element = form.crosshead[l];
                        if (element.stem == ' ' || element.stem == '') {
                            this.error.push(this.saveTextConfig.subjectivity.stemNullMessage.signMix(l + 1))
                            this.is_valid = false
                        }
                        if (element.score === 0) {
                            this.error.push(this.saveTextConfig.subjectivity.zeroMessage.signMix(l + 1))
                            this.is_valid = false
                        }else if (element.score === undefined) {
                            this.error.push(this.saveTextConfig.subjectivity.scoreNullMessage.signMix(l + 1))
                            this.is_valid = false
                        }
                    }
                    // form.crosshead = JSON.stringify(form.crosshead)
                }else {
                    if (form.score === 0) {
                        this.error.push(this.saveTextConfig.scoreZeroMessage)
                        this.is_valid = false
                    }else if (form.score === undefined) {
                        this.error.push(this.saveTextConfig.scoreNullMessage)
                        this.is_valid = false
                    }
                }
                if (form.answer[0] == '' || form.answer[0] == ' ') {
                    this.error.push(this.saveTextConfig.answerNullMessage)
                    this.is_valid = false
                }
                if (this.trainingEnable) {
                    if (this.show_project_url) {
                        form.training_mirror = this.project_url;
                    }
                    if (form.training_label == null) {
                        this.error.push(this.saveTextConfig.trainingNullMessage)
                        this.is_valid = false
                    }
                    if (this.show_project_url && this.project_url == '') {
                        this.error.push(this.saveTextConfig.projectUrlNullMessage)
                        this.is_valid = false
                    }
                    if (this.has_bill) {
                        if (this.specification_id == null ){
                            this.error.push(this.saveTextConfig.specificationNullMessage)
                            this.is_valid = false
                        }
                        if (this.gift_duration == null) {
                            this.error.push(this.saveTextConfig.giveDurationNullMessage)
                            this.is_valid = false
                        }
                        if (this.is_valid) {
                            form.training_bill = {specification_id : this.specification_id, gift_duration: this.gift_duration}
                        }

                    }

                }

                if (form.review_mode === 'script' && !form.review_script) {
                    this.error.push('脚本设置项不可为空')
                    this.is_valid = false
                }

                if (form.review_mode === 'manual' && form.submit_mode.length <= 0) {
                    this.error.push('答题方式不可为空')
                    this.is_valid = false
                }
            }
            if (form.type != 'subjectivity') {
                if (form.score === 0) {
                    this.error.push(this.formTextConfig.scoreZeroMessage)
                    this.is_valid = false
                }else if (form.score === undefined) {
                    this.error.push(this.formTextConfig.scoreNullMessage)
                    this.is_valid = false
                }
            }
            if (this.is_valid) {
                if (this.$route.query.editId) {
                    this.$store.dispatch("putManageQuestion", form).then(res => {
                        this.fullscreenLoading = false
                        if (res.status == 200) {
                            this.$message({
                                type: 'success',
                                message: this.formTextConfig.editSuccess
                            });
                            this.$router.push({path:'/question',query:{id:this.$route.query.parentId}})
                            this.$route.meta.keepAlive = false
                        }
                    });
                }else {
                    this.$store.dispatch("postManageQuestion", form).then(res => {
                        this.fullscreenLoading = false
                        if (res.status == 200) {
                            this.$message({
                                type: 'success',
                                message: this.formTextConfig.addSuccess
                            });
                            if (val) {
                                location.reload();
                            }else {
                                this.$router.push({path:'/question',query:{id:this.$route.query.parentId}})
                                this.$route.meta.keepAlive = false
                            }
                        }
                    });
                }
            } else {
                this.fullscreenLoading = false
                document.getElementById('formEditQuestion').scrollIntoView()
            }
        },
        questionTypeFormatter(val) {
            let already = this.typeList.find(item => item.dict_value == val)
            return already ? already.dict_label : ''
        },
        changeSpecification(item) {
            this.specification_id = item.id
            this.price = item.currentPrice ?item.currentPrice:item.price
            if (item.priceUnit == 'min') {
                this.priceUnitLabel = '分钟'
            } else {
                this.priceUnitLabel = '小时'
            }
            if (this.gift_duration) {
                this.tipdm_icon = this.gift_duration * this.price
                this.tipdm_icon =  this.tipdm_icon.toFixed(2)
            }

        },
        changeGiveDuration() {
            if (this.gift_duration && this.price) {
                this.tipdm_icon = this.gift_duration * this.price
                this.tipdm_icon =  this.tipdm_icon.toFixed(2)
            }
        }
    }
}
</script>

<style scoped>
    .info {
        color: #C0C4CC;
        font-size: 14px;
        line-height: 20px;
        margin-top: 6px;
    }
    .el-form >>> .el-form-item--small .el-form-item__content, .el-form >>> .el-form-item--small .el-form-item__label {
        line-height: 40px;
    }
    .editor {
        width: calc(100% - 60px);
    }
    .editor100p {
        width: 100%;
    }
    .el-radio-group {
        display: block;
    }
    .el-row .el-button {
        margin-left: 15px;
        height: 42px;
    }
    .specifications-list-container {
        background: #f4f5f9;
        padding: 20px 30px 5px 30px;
    }

    ul.specifications-list {
        display: flex;
        padding-left: 0;
        flex-wrap: wrap;
        max-height: 438px;
        overflow-y: auto;
    }
    ul.specifications-list li {
        list-style: none;
        box-sizing: border-box;
        border: 1px solid #e1e1e1;
        border-radius: 4px;
        padding: 6px 20px;
        margin-right: 20px;
        margin-bottom: 12px;
        width: 250px;
        height: 150px;
        color: #000;
        cursor: pointer;
        line-height: 16px;
        padding: 15px;
        background: #fff;
    }
    ul.specifications-list li:nth-child(3n) {
        margin-right: 0px;
    }
    ul.specifications-list li > h5 {
        font-size: 20px;
        white-space: nowrap; /* 不换行 */
        overflow: hidden; /* 超出部分隐藏 */
        text-overflow: ellipsis; /* 显示省略号 */
        line-height: 35px;
        margin-bottom: 10px;
    }
    ul.specifications-list li > p {
        margin: 0 0 4px;
    }
    ul.specifications-list li > p .label {
        color: rgba(0, 0, 0, .56);
    }
    ul.specifications-list li.selected {
        border-color: #99c6f2;
        position: relative;
    }
    ul.specifications-list li.selected h5 {
        color: #000;
    }
    ul.specifications-list li .selected-icon {
        display: none;
    }
    ul.specifications-list li.selected .selected-icon {
        display: block;
        position: absolute;
        top: 1px;
        right: 0;
        color: #fff;
        z-index: 111;
    }
    ul.specifications-list li.selected:after {
        content: '';
        display: block;
        top: 0;
        right: 0;
        background: #99c6f2;
        position: absolute;
        width: 30px;
        height: 30px;
        clip-path: polygon(0 0, 30px 0, 30px 30px);
    }
</style>
